import { GET_MAP, GET_MAP_SUCCESS, GET_MAP_ERROR} from './actionTypes';

export const getMap = (user, size, page, search, type, status) => {
    return {
        type: GET_MAP,
        payload: { user, size, page, search, type, status }
    }
}

export const getMapSuccess = (map, message) => {
    return {
        type: GET_MAP_SUCCESS,
        payload: {map, message}
    }
}

export const getMapError = (message) => {
    return {
        type: GET_MAP_ERROR,
        payload: message
    }
}
